import styled from 'styled-components'

export const MainContainer = styled.div<{ $justifyContent: string }>`
  width: 100%;
  padding: 0.5rem 1rem;
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  justify-content: ${({ $justifyContent }) => $justifyContent};

  @media (min-width: 768px) {
    max-width: 608px;
    border: unset;
  }
`

export const SliderButton = styled.button<{
  $color?: string
  $hasFixedSize?: boolean
  $orientation?: 'horizontal' | 'vertical'
}>`
  background-color: transparent;
  border: none;
  border-radius: 100%;
  padding: 0;
  outline: 0;

  ${({ $orientation }) =>
    $orientation === 'vertical' && 'transform: rotate(90deg);'}

  > figure {
    outline: 0;
    padding: 0;

    width: 24px;
    height: 24px;

    ${({ $hasFixedSize }) =>
      !$hasFixedSize &&
      `
      @media (min-width: 768px) {
        width: 40px;
        height: 40px;
      }
    `}
  }

  &:disabled > figure {
    padding: 2px;

    @media (min-width: 768px) {
      padding: 4px;
    }
  }

  &:focus {
    outline: none;
    > figure {
      > svg > path:first-child {
        fill: #abbed1;
      }
    }
  }

  > figure {
    pointer-events: none;
    &:focus {
      outline: none;

      > svg > path:first-child {
        fill: #abbed1;
      }
    }
  }
`

export const CenterText = styled.div<{ $color?: string }>`
  text-align: center;
  color: ${(props) => props.$color || '#303032'};
  font-family: Barlow;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;

  @media (min-width: 768px) {
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
  }
`

export const NavigationTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  > img {
    width: 24px;
    height: 24px;
  }
`
